import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Eye, Pencil, Plus, Trash2, LogIn, LogOut, Tag, KeyRound, User, ShieldCheck, ShieldOff, UsersRound, UserMinus, Download, AlertTriangle } from "lucide-react";

const ACTION_META = {
  create:                { label: "Criou", icon: Plus, color: "#10B981" },
  update:                { label: "Editou", icon: Pencil, color: "#0EA5E9" },
  delete:                { label: "Excluiu", icon: Trash2, color: "#DC2626" },
  reveal_secret:         { label: "Visualizou senha", icon: Eye, color: "#F59E0B" },
  reveal_secret_denied:  { label: "Tentativa negada", icon: AlertTriangle, color: "#DC2626" },
  login:                 { label: "Login", icon: LogIn, color: "#6B7280" },
  logout:                { label: "Logout", icon: LogOut, color: "#6B7280" },
  grant_access:          { label: "Liberou acesso", icon: ShieldCheck, color: "#10B981" },
  revoke_access:         { label: "Removeu acesso", icon: ShieldOff, color: "#DC2626" },
  add_to_group:          { label: "Adicionou ao cofre", icon: UsersRound, color: "#10B981" },
  remove_from_group:     { label: "Removeu do cofre", icon: UserMinus, color: "#DC2626" },
  export:                { label: "Exportou", icon: Download, color: "#A855F7" },
  export_denied:         { label: "Exportação negada", icon: AlertTriangle, color: "#DC2626" },
};

const ENTITY_META = {
  credential: { label: "Credencial", icon: KeyRound },
  category:   { label: "Categoria",  icon: Tag },
  group:      { label: "Cofre",      icon: UsersRound },
  user:       { label: "Usuário",    icon: User },
};

function formatDateTime(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return "—"; }
}

export default function AuditPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold" style={{ color: "#FF8A00" }}>Segurança</div>
        <h2 className="font-display font-bold text-3xl mt-1 text-[#1F1F24]">Auditoria</h2>
        <p className="text-gray-600 text-sm mt-1">Trilha de ações realizadas no sistema.</p>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
        {loading ? <div className="text-gray-500 p-8 text-center">Carregando...</div> :
          items.length === 0 ? <div className="text-gray-500 p-8 text-center">Nenhum registro de auditoria.</div> :
          <ul className="divide-y divide-gray-100">
            {items.map((a) => {
              const am = ACTION_META[a.action] || { label: a.action, icon: Eye, color: "#6B7280" };
              const em = ENTITY_META[a.entity_type] || { label: a.entity_type, icon: KeyRound };
              const ActionIcon = am.icon;
              const EntityIcon = em.icon;
              return (
                <li key={a.id} className="px-5 py-4 flex items-start gap-4 hover:bg-gray-50" data-testid={`audit-row-${a.id}`}>
                  <div className="w-10 h-10 rounded-lg shrink-0 flex items-center justify-center"
                       style={{ background: `${am.color}18`, color: am.color }}>
                    <ActionIcon className="w-5 h-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-[#1F1F24]">
                      <span className="font-semibold">{a.user_name || a.user_email || "—"}</span>
                      {" "}<span className="text-gray-600">{am.label.toLowerCase()}</span>
                      {" "}<span className="inline-flex items-center gap-1 text-gray-500 text-xs">
                        <EntityIcon className="w-3 h-3" /> {em.label}
                      </span>
                      {" "}{a.entity_name && <span className="font-semibold">"{a.entity_name}"</span>}
                    </div>
                    {a.details && <div className="text-xs text-gray-500 mt-0.5">{a.details}</div>}
                  </div>
                  <div className="text-xs text-gray-500 whitespace-nowrap">{formatDateTime(a.timestamp)}</div>
                </li>
              );
            })}
          </ul>
        }
      </div>
    </div>
  );
}
